import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { ErrorMessageModule } from '../error-message/error-message.module';
import { TooltipMessageModule } from '../tooltip-message/tooltip-message.module';
import { InputNumber } from '../utils/models/InputNumber';
import { InputNumberComponent } from './input-number.component';
import { InputNumberService } from './input-number.service';

const maskConfig: Partial<IConfig> = {
	validation: false,
};


@NgModule({
  declarations: [InputNumberComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
		ReactiveFormsModule,
    ErrorMessageModule,
    TooltipMessageModule,
    MatTooltipModule,
    NgxMaskModule.forRoot(maskConfig)
  ],
  exports: [InputNumberComponent]
})
export class InputNumberModule { 
  static forRoot(inputNumber: InputNumber = new InputNumber()): ModuleWithProviders<InputNumberModule> {
    return {
      ngModule: InputNumberModule,
      providers: [
        { provide: 'INPUT_NUMBER_DECIMALS', useValue: inputNumber.decimals },
        { provide: 'INPUT_NUMBER_FORMAT_CERO', useValue: inputNumber.formatCero },
        { provide: 'INPUT_NUMBER_BTN_ENABLE', useValue: inputNumber.btnEnable },
        { provide: 'INPUT_NUMBER_BOLD', useValue: inputNumber.bold },
        { provide: 'INPUT_NUMBER_VALIDATOR_MESSAGE', useValue: inputNumber.validatorMessage },
        { provide: 'INPUT_NUMBER_TOOLTIP_MESSAGE', useValue: inputNumber.tooltipMessage },
        { provide: 'INPUT_NUMBER_SUBMITTED', useValue: inputNumber.submitted },
        { provide: 'INPUT_NUMBER_VALIDATOR_ALERT', useValue: inputNumber.validatorAlert },
        InputNumberService
      ]
    }
  }
}
